import { ROUTE_PATH } from "@/common/constants/routing";
import {
  AppPermission,
  AssetSubscriptionPlanDto,
  AssetSubscriptionPlanReferenceDto,
} from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import AssetSubscriptionPlanInline, {
  AssetSubscriptionPlanInlineProps,
} from "./AssetSubscriptionPlanInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity?: AssetSubscriptionPlanDto | AssetSubscriptionPlanReferenceDto;
  entityId?: string | null;
  inlineProps?: Partial<AssetSubscriptionPlanInlineProps>;
}

export default function AssetSubscriptionPlanLink({
  entity,
  entityId,
  inlineProps,
  ...otherProps
}: Props) {
  if (!entity && !entityId) {
    return null;
  }

  // const full = entity as AssetSubscriptionPlanDto;
  // const reference = entity as AssetSubscriptionPlanReferenceDto;

  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.AssetSubscriptionPlanRead]}
      to={ROUTE_PATH.ASSET_SUBSCRIPTION_PLAN_VIEW(entity?.id || "")}
      content={<AssetSubscriptionPlanInline entity={entity} entityId={entityId} {...inlineProps} />}
      {...otherProps}
    />
  );
}
